import { string, struct } from 'io-ts/Decoder';

export const Param = struct({
	jwt: string,
});
